import { Injectable } from '@angular/core';
import { HttpService } from '../helper/http.service';
import { environment } from '../../../environments/environment';
import { EndPoints } from '../../../configs/api.config';
import { GenericHttpResponse } from '../../models/http-response.model';
import { SystemConfig } from '../../models/config.model';
import { SystemConfigs } from '../../utilities/utils';
import { BetPaymentDelay } from '../../models/status.payment.type';
import { CurrencyParam } from '../../models/currency.model';
import { printerInfo } from '../../models/printer';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  [key: string]: string | any;
  currency!:string;
  displayCurrency!:string;
  betFormatVersion!:string;
  raceShortNameFormat!:string;
  printerInfo: printerInfo = {
    name: 'Me',
    cpl: 42,
    type: 'http',
    printer: {
      domain: "http://127.0.0.1",
      port:"18091"
    }
  };
  betPaymentWait!: BetPaymentDelay;
  taxOnStake!: boolean;
  currencyData: CurrencyParam = {
      strCode: 'XOF',
      bDefault: true,
      dbValue: 1,
      strGroupingSeparator: ',',
      strDecimalSeparator: '.',
      strDisplayFormat: '#,###,###,##0',
      bCodeAppendedEnd: true,
      bAddCodeValueSeparator: true,
      strCodeValueSeparator: ' ',
      intFractionsCount: 0,
    };

  constructor(private readonly httpService: HttpService, private readonly http: HttpClient) {
    this.betFormatVersion = '4.3';
    this.betPaymentWait = {
      recursive: 10 * 1000,
      checkStatus: 60 * 1000,
      initial: 30 * 1000,
    }
  }

  loadConfig() {
    return firstValueFrom(this.http.get('assets/config/config.json'))
      .then((config: any) => {
        this.printerInfo.name = config.printerName;
        this.printerInfo.cpl = Number(config.cpl);
        this.printerInfo.type = config.type;
        this.printerInfo.printer = config.printer;
      });
  }

  getSystemConfigs() {
    const [gw, api] = [environment.API.sportsGateway, EndPoints.systemConfigs];
    this.httpService.getRequest<Partial<GenericHttpResponse<SystemConfig[]>>>(gw, api).pipe().subscribe(
        (res: Partial<GenericHttpResponse<SystemConfig[]>>) => {
          if (res.data?.length) {
            SystemConfigs.forEach(config => {
               this[config.name] = this.getValue_new(config.key, (res.data || []), config.default);
            });
          }
        }
      );
  }

getValue_new(key: string, arr: Array<any>, def:any): any {
    if (!arr.length) return def;
    let returnVal: any = arr.find((config) => config.key === key);
    if(!returnVal) return def;
    switch (typeof def) {
      case 'string':
      case 'object':
        return returnVal['value'];
      case 'number':
        return parseInt(returnVal['value']);
      case 'boolean':
        return JSON.parse(returnVal['value']);
      default:
        return def;
    }
  }
}
